import axios from 'axios';

export default {
    namespaced: true,
    state: {
        user: [],
        loginstatus: false,
        loginToken: '',
        error: '',
        email: '',
        userAllowedItemIds: [],
        lastLogin: null,
    },

    mutations: {
        setUserAllowedItemIds(state, ids) {
            state.userAllowedItemIds = ids;
        },
        SET_LOGIN_STATUS(state, status) {
            state.loginstatus = status;
        },
        SET_LOGIN_TOKEN(state, loginToken) {
            state.loginToken = loginToken;
        },
        SET_EMAIL(state, email) {
            state.email = email;
        },
        /*
        SET_USER(state){
            state.user.push({
                email : state.email,
                token : state.loginToken
            });
        },
        */
        SET_USER(state, user) {
            state.user.push({
                email: state.email,
                token: state.loginToken
            });
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
        SET_LAST_LOGIN(state, lastLogin) {
            state.lastLogin = lastLogin;
        },
    },

    actions: {
        async login({ commit, rootState }, { email, password }) {

            const apiPreUrl = rootState.url.apiPreUrl;


            try {
                const requestData = {
                    email,
                    password,
                };
                const response = await axios.post(
                    `${apiPreUrl}/api/v1.0/auth/login`,
                    requestData
                );
                if (response.data.token) {
                    const userJson = {
                        token: response.data.token,
                        email,
                        user_id: response.data.userId,
                        last_login: response.data.updated_at,
                    };
                    sessionStorage.setItem('user', JSON.stringify(userJson));
                    commit('SET_EMAIL', email);
                    commit('SET_LOGIN_STATUS', true);
                    commit('SET_LOGIN_TOKEN', response.data.token);
                    commit('SET_LAST_LOGIN', response.data.updated_at);

                }
            } catch (error) {
                commit('SET_ERROR', error);
                commit('SET_LOGIN_STATUS', false);
                throw error;
            }
        },
        createAccount({ commit, rootState }, { name, email, password }) {
            //let isLoggedIn = 0;
            const apiPreUrl = rootState.url.apiPreUrl;
            axios({
                method: "POST",
                url: `${apiPreUrl}/api/v1.0/auth/register`,
                params: {
                    name: name,
                    email: email,
                    password: password,
                },
            })
                .then(function (response) {
                    //console.log(response);
                })
                .catch(function (error) {
                    //console.log(error);
                });
        },
        logout({ commit }) {
            commit('SET_USER', null);
            commit('SET_LOGIN_STATUS', 0);
            commit('SET_EMAIL', null);
            commit('SET_LOGIN_TOKEN', null);
        },
        fetchUserAllowedItemIds({ commit, rootState }) {
            //console.log('test');
            const apiPreUrl = rootState.url.apiPreUrl;
            const frontUrl = `${window.location.protocol}//${window.location.host}`;
            const user = JSON.parse(sessionStorage.getItem("user"));
            const params = {
                user_id: user.user_id,
                ip: frontUrl
            };
            const response = axios.get(apiPreUrl + `/api/livelist`, {
                params,
            });
            const fetchedIds = response.data.id

            commit('setUserAllowedItemIds', fetchedIds);
        }
    },

    getters: {
        isLoggedIn(state) {
            return state.loginstatus;
        },
        user(state) {
            return state.user;
        },
        getLoginToken(state) {
            return state.loginToken;
        },
        email(state) {
            return state.email;
        },
        userAllowedItemIds: (state) => {
            return state.userAllowedItemIds;
        }

    }
}